export const FOREIGN_RFC_FALLBACK = 'XEXX010101000';

export const CONTRIBUTOR_SECTIONS = [
  {
    key: 'fiscal-ident',
    icon: 'fa-id-card-o',
  },
  {
    key: 'fiscal-address',
    icon: 'fa-map-marker',
  },
  {
    key: 'bank-data',
    icon: 'fa-university',
  },
];

export const createInitialContributorForm = () => ({
  constanciaFile: null,
  constanciaFileName: '',
  default: 0,
  type: { value: 0, label: 'Nacional' },
  taxIdentifier: '',
  name: '',
  zipcode: '',
  regimen: null,
  usoCfdi: null,
  paymentMethod: null,
  paymentMethodType: null,
  skipFiscalAddress: false,
  state: null,
  municipality: '',
  street: '',
  exterior: '',
  interior: '',
  neighborhood: '',
  paymentAccount: '',
  beneficiaryBankRfc: '',
  orderingBank: '',
  orderingBankRfc: '',
  orderingBankAccount: '',
});
